import React, { ChangeEvent, useEffect, useState } from 'react';
import {XIcon} from 'assests/GmsIcons';
import {
    EXCLUSION_DEFAULT,
    EXCLUSION_OPTIONS
} from "../../../ISRConstants";
import ToggleButton from "../../../../../../Components/Common/components/Inputs/ToggleButton";
import OverlayIcon from "../../../../../../Components/GMS/Rules/Components/OverlayIcon";

type EditSubmodelProps = {
    submodel: any;
    pageName: string;
    setSubmodelEditFlag: (flag: boolean) => void;
    uiConfig: any;
    updateDataModelLayout: (dataModelIndex: number, layout: string | null, inclusion: string | null, exclusion: string | null, displayName: string | null, hideWhenNoProductsAvailable: boolean | null) => void;
}

const EditSubmodel = ({submodel, pageName, setSubmodelEditFlag, updateDataModelLayout, uiConfig}: EditSubmodelProps) => {
    const [uiSubmodel, setUiSubmodel] = useState<any>();

    useEffect (() => {
        setUiSubmodel(submodel);
    }, []);

    const handleViewPrefChange = (layout: string) => {
        const updatedUiSubmodel = uiSubmodel;
        updatedUiSubmodel.submodel.config.viewPref = layout;
        setUiSubmodel(JSON.parse(JSON.stringify(updatedUiSubmodel)));
    }

    const handleExclusionChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const exclusion = event.target.value;
        const updatedUiSubmodel = uiSubmodel;
        updatedUiSubmodel.submodel.config.exclusion = exclusion;
        setUiSubmodel(JSON.parse(JSON.stringify(updatedUiSubmodel)));
    }

    const handleInclusionChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const inclusion = event.target.value;
        const updatedUiSubmodel = uiSubmodel;
        updatedUiSubmodel.submodel.config.inclusion = inclusion;
        setUiSubmodel(JSON.parse(JSON.stringify(updatedUiSubmodel)));
    }

    const handleChangeDisplayName = (value: string) => {
        const updatedUiSubmodel = uiSubmodel;
        updatedUiSubmodel.submodel.config.displayName = value;
        setUiSubmodel(JSON.parse(JSON.stringify(updatedUiSubmodel)));
    }

    const handleHideWhenNoProductsAvailableChange = (value: boolean) => {
        const updatedUiSubmodel = uiSubmodel;
        updatedUiSubmodel.submodel.config.hideWhenNoProductsAvailable = value;
        setUiSubmodel(JSON.parse(JSON.stringify(updatedUiSubmodel)));
    };

    useEffect(() => {
        if (uiSubmodel) {
            //updateField(uiSubmodel, fieldIndex, modelIndex);
            updateDataModelLayout(uiSubmodel.modelIndex, uiSubmodel.submodel.config.viewPref, uiSubmodel.submodel.config.inclusion, uiSubmodel.submodel.config.exclusion, uiSubmodel.submodel.config.displayName, uiSubmodel.submodel.config.hideWhenNoProductsAvailable)
        }
    }, [uiSubmodel]);
    const viewPrefIsGrid = uiSubmodel?.submodel?.config?.viewPref === undefined ? uiConfig.customization.viewPref : uiSubmodel?.submodel?.config?.viewPref;
    return(
        <div className="tw-w-[375px] tw-absolute tw-h-[95vh] tw-bg-white tw-shadow tw-float-right tw-right-0 tw-top-0" style={{zIndex: 1000}}>
            <div className="tw-text-sky-950 tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-leading-tight tw-my-[18px] tw-mx-[12px]">{uiSubmodel?.submodel?.name}</div>
            <button aria-label="Close" data-testid="components-editsubmodel-button-1" className="tw-text-black tw-float-right tw-my-[-36px] tw-mx-[24px]" onClick={()=>setSubmodelEditFlag(false)}>
                <XIcon />
            </button>
            <div className="tw-w-[373px] tw-h-[0px] tw-border tw-border-zinc-300"/>

            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb-2 tw-mx-[12px]">Exclusions</div>
            <select data-testid="components-editsubmodel-select-2" className="drop-down-dm tw-w-[180px] tw-py-2 tw-mx-[12px] tw-h-[36px] tw-w-[335px]" value={uiSubmodel?.submodel?.config?.exclusion ?? EXCLUSION_DEFAULT} onChange={handleExclusionChange} >
                {EXCLUSION_OPTIONS.map((item, index) => {
                    return (
                        <option value={item} key={item + index}>
                        {item}
                    </option>);
                })}
            </select>
            {/*<div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb-2 tw-mx-[12px]">Inclusions</div>*/}
            {/*<select className="drop-down-dm tw-w-[180px] tw-py-2 tw-mx-[12px] tw-h-[36px] tw-w-[335px]" value={uiSubmodel?.submodel?.config?.inclusion ?? INCLUSION_DEFAULT} onChange={handleInclusionChange} >*/}
            {/*    {INCLUSION_OPTIONS.map((item, index) => {*/}
            {/*        return (*/}
            {/*            <option value={item} key={item + index}>*/}
            {/*            {item}*/}
            {/*        </option>);*/}
            {/*    })}*/}
            {/*</select>*/}

            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-my-[18px] tw-mx-[12px]">Product view preference</div>
            <div className="tw-flex tw-mx-4">
                <div className="tw-flex tw-items-center tw-me-4">
                    <input data-testid="components-editsubmodel-input-3" checked={viewPrefIsGrid !== "grid"} id="inline-radio" type="radio" value="" name="inline-radio-group" onChange={()=> handleViewPrefChange("list")} className="tw-w-4 tw-h-4 tw-text-blue-600 tw-bg-gray-100 tw-border-gray-300 focus:tw-ring-accent-hover tw-dark:focus:ring-blue-600 tw-dark:ring-offset-gray-800 focus:tw-ring-2 tw-dark:bg-gray-700 tw-dark:border-gray-600"/>
                    <label htmlFor="inline-radio" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">List</label>
                </div>
                <div className="tw-flex tw-items-center tw-me-4 ">
                    <input data-testid="components-editsubmodel-input-4" checked={viewPrefIsGrid === "grid"} id="inline-2-radio" type="radio" value="" name="inline-radio-group" onChange={()=> handleViewPrefChange("grid")} className="bg-gray-100 border-gray-300 tw-w-4 tw-h-4 tw-text-blue-600 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                    <label htmlFor="inline-2-radio" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">Grid</label>
                </div>

                {/*<div className="tw-flex tw-items-center tw-me-4">*/}
                {/*    <input checked={uiSubmodel?.submodel?.config?.viewPref === "carousel"} id="inline-3-radio" type="radio" value="" name="inline-radio-group" onChange={() => handleViewPrefChange("carousel")} className="bg-gray-100 border-gray-300 tw-w-4 tw-h-4 tw-text-blue-600 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>*/}
                {/*    <label htmlFor="pref-3-radio" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">Carousel</label>*/}
                {/*</div>*/}
            </div>

            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb-2 tw-mx-[12px]">Title</div>
            <input data-testid="components-editsubmodel-input-5" className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-[335px] tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-grey-550 focus:tw-outline-none tw-mx-[12px]"
                type='text'
                value={uiSubmodel?.submodel?.config?.displayName ?? uiSubmodel?.submodel?.name ?? ''}
                onChange={(e) => {
                    handleChangeDisplayName(e.target.value)
                }}
                placeholder={'Title'}
            />

            <label className="tw-text-slate-500 tw-mt-[18px] tw-mb-2 tw-ms-[12px] ">
                {'Hide, when no products are available'}
                <span className="tw-ml-1 tw-inline-block">
                    <OverlayIcon
                        message="When enabled, automatically hides the sections (Page/SubModel/Category) if no compatible products are available"
                        placement="bottom"
                    />
                </span>
            </label>
            <div className="tw-mx-[12px]">
                <ToggleButton
                    name="HideWhenNoProductsAvailable"
                    value={uiSubmodel?.submodel?.config?.hideWhenNoProductsAvailable ?? false}
                    onChange={(e) => handleHideWhenNoProductsAvailableChange(e.target.checked)}
                />
            </div>

            <button data-testid="components-editsubmodel-button-6" onClick={() => {setSubmodelEditFlag(false)}} className="small-filled-btn tw-px-[24px] tw-h-[30px] tw-mx-[12px] tw-mt-[18px]">Done</button>
        </div>
    );
}

export default EditSubmodel;
